import { ChangePasswordResponse, ConfirmPersonResponse, SessionResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * A vendedora confirma que é ela, com a senha dela, sem trocar quem está
 * logado (F298).
 */
export const confirmPerson = async (input) => ConfirmPersonResponse.parse(await request('/api/v1/auth/confirm-person', {
    method: 'POST',
    body: input,
}));
/**
 * `/api/v1/auth` — entrar, sair, saber quem se é e trocar de contexto.
 *
 * `switchContext` é o que troca empresa e filial: o contexto vive na SESSÃO
 * do servidor, nunca num estado do navegador, porque é ele que decide o
 * escopo de tenant de toda consulta seguinte.
 */
/**
 * O site manda só e-mail e senha (e ganha o cookie). O celular manda também
 * `transport: 'bearer'`, `client: 'mobile'` e o nome do aparelho (F304).
 */
export const login = async (input) => SessionResponse.parse(await request('/api/v1/auth/login', { method: 'POST', body: input }));
export const fetchSession = async (signal) => SessionResponse.parse(await request('/api/v1/auth/me', { signal }));
export const logout = async () => {
    await request('/api/v1/auth/logout', { method: 'POST' });
};
export const switchContext = async (input) => SessionResponse.parse(await request('/api/v1/auth/context', { method: 'POST', body: input }));
/**
 * Sai do acesso de suporte e volta para a conta de origem (F169).
 *
 * Não passa pelo console: durante o suporte a sessão deixa de ser
 * administradora da plataforma, de propósito, então a saída tem de morar em
 * `/auth` — que é o conjunto que continua alcançável de dentro da loja.
 */
export const exitSupport = async () => SessionResponse.parse(await request('/api/v1/auth/support/exit', { method: 'POST' }));
export const changePassword = async (input) => ChangePasswordResponse.parse(await request('/api/v1/auth/password', { method: 'POST', body: input }));
//# sourceMappingURL=auth.js.map